








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { ERecipientStatus } from '@signing-page/recipient/types/enums/recipient-status';
import Avatar from '@/components/Avatar.vue';
import { translateEnum } from '@/helpers/translation.helper';
import { ERecipientRole } from '@/dealroom/recipients/types/enums/recipient-role';

@Component({
  components: {
    Avatar,
  },
})
export default class RecipientsTable extends Vue {
  @Prop() recipients: IRecipient[];
  @Prop() isSigningOrder: number;
  @Prop({ default: 3 }) showNumRecipients: number;
  @Prop({ default: 6 }) rowHeight: number;

  ERecipientStatus = ERecipientStatus;

  get recipientsTitle(): string {
    return `${this.$t('recipients').toString()} (${this.recipients.length})`;
  }

  get recipientsOrderSorted(): IRecipient[] {
    return [...this.recipients].sort((recipient1: IRecipient, recipient2: IRecipient) =>
      recipient1.orderNum < recipient2.orderNum ? -1 : 1
    );
  }

  name(recipient): string {
    if (recipient.fullName) {
      return recipient.fullName;
    } else if (recipient.email) {
      return recipient.email;
    } else {
      return recipient.mobile;
    }
  }

  checked(recipient: IRecipient): boolean {
    if (recipient.role === ERecipientRole.CC && recipient.status === ERecipientStatus.Reviewed) {
      return true;
    }
    const checkedStatuses: ERecipientStatus[] = [
      ERecipientStatus.Signed,
      ERecipientStatus.Approved,
    ];
    return checkedStatuses.some((status: ERecipientStatus) => status === recipient.status);
  }

  title(recipient: IRecipient): string {
    const { title, companyName } = recipient;
    if (title && companyName) {
      return `${title} ${this.$t('at')} ${companyName}`;
    }
    if (title) {
      return title;
    }
    if (companyName) {
      return companyName;
    }
  }

  role(recipient: IRecipient): string {
    return recipient.role ? translateEnum(recipient.role, 'recipient-role', ERecipientRole) : '-';
  }

  status(recipient: IRecipient): string {
    return recipient.status
      ? translateEnum(recipient.status, 'recipient-status', ERecipientStatus)
      : '-';
  }
}
